var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.orderAside }, [
    _c(
      "div",
      {
        class: _vm.$style.orderStepsAside,
        on: { click: _vm.menuClickHandler }
      },
      [
        _c("svg", {
          directives: [{ name: "svg", rawName: "v-svg" }],
          class: _vm.$style.menuIcon,
          attrs: { symbol: "menu-icon" }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("Menu")])
      ]
    ),
    _vm._v(" "),
    _c("div", { class: _vm.$style.orderAsideBody }, [
      _c("h4", { class: _vm.$style.orderAsideTitle }, [
        _vm._v(_vm._s(_vm.currentProduct.name))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.orderAsideList },
        _vm._l(_vm.sortedCategories, function(categoryKey, index) {
          return _c("ConfiguratorSelectedOptionsGroup", {
            key: index + "SelectedOption",
            attrs: {
              "category-key": categoryKey,
              "configurator-category": _vm.configuratorCategory
            }
          })
        }),
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.orderAsideFooter }, [
      _c("div", { class: _vm.$style.orderAsidePrice }, [
        _c("h6", [_vm._v("Item Price")]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm._f("toPrice")(_vm.price)))])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { class: _vm.$style.orderAsideBtn, on: { click: _vm.handleStartOver } },
        [_vm._v("\n      Start Over\n    ")]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/ConfiguratorCurrentBurger.vue?vue&type=template&id=e8a30dd4&
// module id = null
// module chunks = 